import SignUp from 'components/pages/SignUp/SignUp';
import Homepage from 'components/pages/Homepage/Homepage';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('homepage', {
  fadedPageBg: true,
  fadedPageBgMobile: true,
  isLandingPage: true,
});

export default buildPage(Homepage, {
  skipSSR: true,
  metaData: {
    title: 'Qmee – Paid Online Surveys - Shop to earn real cash rewards',
    description:
      'Qmee cash rewards, discounts &amp; surveys. Search, earn and save today and put cash back in your wallet.',
  },
  loggedInRedirect: '/dashboard',
});
